import { useState } from 'react';
import styled from 'styled-components';
import {
  DndContext,
  DragOverlay,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';

import { PostsContainer } from './PostsContainer.jsx';
import { Shelf } from '../Shelf/Shelf.jsx';
import { useCampaignDnd } from '../../hooks/useCampaignDnd';
import { TileCard } from '../Tiles/TileCard.jsx';

export const PostsStep = ({ campaign }) => {
  const isDisabled = campaign.isArchived || !!campaign.deletedAt;
  const [activeTile, setActiveTile] = useState(null);
  const { handleDragEnd, handleDragOver, handleDragStart } = useCampaignDnd({
    setActiveTile,
  });

  const pointerSensor = useSensor(PointerSensor, {
    activationConstraint: {
      distance: 5,
    },
  });
  const sensors = useSensors(pointerSensor);

  return isDisabled ? (
    <Container>
      <PostsContainer
        posts={campaign.posts}
        campaignUuid={campaign.uuid}
        campaignEndDate={campaign.endDate}
      />
      <DragOverlay>
        {activeTile ? <TileCard tile={activeTile} /> : null}
      </DragOverlay>
    </Container>
  ) : (
    <DndContext
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragOver={handleDragOver}
      sensors={sensors}
    >
      <Container>
        <PostsContainer
          posts={campaign.posts}
          campaignUuid={campaign.uuid}
          campaignEndDate={campaign.endDate}
        />
        <Shelf campaignId={campaign.uuid} />
        <DragOverlay>
          {activeTile ? <TileCard tile={activeTile} /> : null}
        </DragOverlay>
      </Container>
    </DndContext>
  );
};

const Container = styled.div`
  display: flex;
  margin: auto;
  gap: 10px;
  justify-content: center;
`;
